import { Workspace } from "../types"

type ResolveWorkspaceSelectionParams = {
  workspaces?: Array<Workspace | null | undefined> | null
  activeWorkspaces?: Array<Workspace | null | undefined> | null
  storedWorkspaceId?: string | null
}

export const getAvailableWorkspaces = (
  workspaces?: Array<Workspace | null | undefined> | null
): Array<Workspace> => {
  return (workspaces ?? []).filter((workspace): workspace is Workspace => Boolean(workspace?.id))
}

export const resolveWorkspaceSelection = ({
  workspaces,
  activeWorkspaces,
  storedWorkspaceId,
}: ResolveWorkspaceSelectionParams): string | null => {
  const availableWorkspaces = getAvailableWorkspaces(workspaces)
  if (!availableWorkspaces.length) return null

  const activeWorkspaceId = (activeWorkspaces ?? []).find((workspace) => {
    return workspace?.id && availableWorkspaces.some((availableWorkspace) => availableWorkspace.id === workspace.id)
  })?.id

  if (activeWorkspaceId) return activeWorkspaceId

  if (storedWorkspaceId && availableWorkspaces.some((workspace) => workspace.id === storedWorkspaceId)) {
    return storedWorkspaceId
  }

  return availableWorkspaces[0]?.id ?? null
}
